import React, { useEffect, useState } from "react";
import HomeIcon from "@mui/icons-material/Home";
import ContentPage from "../Components/ContentPage";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  IconButton,
  Typography,
  Divider,
  Stack,
  FormGroup,
  FormControlLabel,
  Switch,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { settingList, settingUpdate } from "../store/Slice/settingSlice";
import { URL_IMAGE } from "../Config";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});
export default function Setting() {
  const [files, setFiles] = useState([]);
  const dispatch = useDispatch();
  const setting = useSelector(({ setting }) => setting);

  useEffect(() => {
    dispatch(settingList());
  }, []);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sys_name: setting.result.NAME || "",
      sys_title_report: setting.result.TITLE_REPORT || "",
      sys_title_sub: setting.result.TITLE_SUB || "",
      sys_address1: setting.result.ADDRESS1 || "",
      sys_address2: setting.result.ADDRESS2 || "",
      sys_phone: setting.result.PHONE || "",
      sys_logo_img: "",
      status_register: setting.result.STATUS_REGISTER || "Y",
    },
    onSubmit: (values) => {
      // console.log(values);
      dispatch(settingUpdate(values));
    },
  });

  const handleFileChange = (event) => {
    formik.setFieldValue("sys_logo_img", event.target.files[0]);
    const selectedFiles = Array.from(event.target.files);
    setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };
  return (
    <Container maxWidth={"xl"}>
      <ContentPage
        image_icon={process.env.PUBLIC_URL + "/icons/settings.png"}
        title="ตั้งค่าระบบ"
        TitlePageMenulist={[
          {
            label: "หน้าแรก",
            href: "/lab",
            icon: <HomeIcon fontSize="small" />,
          },
        ]}
      >
        <Paper
          variant="outlined"
          component={"form"}
          onSubmit={formik.handleSubmit}
          elevation={0}
          sx={{ p: 1 }}
        >
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="flex-start"
            spacing={2}
          >
            <Grid item xs={12} md={12}>
              <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
                ข้อมูลระบบ
              </Typography>
              <Divider />
            </Grid>
            <Grid item xs={12} md={6}>
              <Stack direction={"column"} spacing={2}>
                <TextField
                  id="sys_name"
                  label="ชื่อระบบ"
                  value={formik.values.sys_name}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="sys_name"
                  onChange={formik.handleChange}
                />
                <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
                  ข้อมูลใบรายงานผล
                </Typography>
                <Divider />
                <TextField
                  id="sys_title_report"
                  label="ใบรายงานผล"
                  value={formik.values.sys_title_report}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="sys_title_report"
                  onChange={formik.handleChange}
                />
                <TextField
                  id="sys_title_sub"
                  label="ใบรายงานผล(เพิ่มเติม)"
                  value={formik.values.sys_title_sub}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="sys_title_sub"
                  onChange={formik.handleChange}
                />
                <TextField
                  id="sys_address1"
                  label="ที่อยู่ ตำบล อำเภอ"
                  value={formik.values.sys_address1}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="sys_address1"
                  onChange={formik.handleChange}
                />
                <TextField
                  id="sys_address2"
                  label="จังหวัด เลขไปรษณี"
                  value={formik.values.sys_address2}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="sys_address2"
                  onChange={formik.handleChange}
                />
                <TextField
                  id="sys_phone"
                  label="เบอร์ติดต่อ Fax."
                  value={formik.values.sys_phone}
                  fullWidth
                  variant="outlined"
                  size="small"
                  name="sys_phone"
                  onChange={formik.handleChange}
                />
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="body1" sx={{ fontWeight: "bold", mb: 1 }}>
                รูปโลโก้ระบบ
              </Typography>
              <Divider />
              {/* Display Preview */}
              {files.length > 0 ? (
                <Paper variant="outlined" sx={{ mt: 1 }}>
                  {files.map((file, index) => (
                    <Box key={index}>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        mb={1}
                      >
                        <img
                          src={URL.createObjectURL(file)}
                          alt={file.name}
                          width={200}
                          height={200}
                          style={{ objectFit: "cover" }}
                        />
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="center"
                        alignItems="center"
                        mb={1}
                      >
                        <IconButton
                          onClick={() => handleRemoveFile(index)}
                          color="error"
                          aria-label="remove"
                          size="small"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Box>
                    </Box>
                  ))}
                </Paper>
              ) : (
                <Paper variant="outlined" sx={{ mt: 1 }}>
                  <Box>
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      mb={1}
                    >
                      <img
                        src={URL_IMAGE + setting.result.LOGO}
                        alt={"logo"}
                        width={200}
                        height={200}
                        style={{ objectFit: "cover" }}
                      />
                    </Box>
                  </Box>
                </Paper>
              )}
              <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                <Button
                  component="label"
                  role={undefined}
                  variant="contained"
                  tabIndex={-1}
                  startIcon={<CloudUploadIcon />}
                  onChange={handleFileChange}
                  color="secondary"
                >
                  Upload Logo
                  <VisuallyHiddenInput
                    type="file"
                    onChange={(event) => console.log(event.target.files)}
                  />
                </Button>
              </Box>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormGroup>
                <FormControlLabel
                  control={
                    <Switch checked={formik.values.status_register === "Y"} />
                  }
                  label="สมัครสมาชิก"
                  onChange={(e) => {
                    let checked = e.target.checked ? "Y" : "N";
                    formik.setFieldValue("status_register", checked);
                  }}
                />
              </FormGroup>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Button
                variant="contained"
                sx={{ mt: 5 }}
                type="submit"
                startIcon={<SaveAltIcon />}
              >
                อัพเดท
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </ContentPage>
    </Container>
  );
}
